var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistrationDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.59,
    height: 117.576,
    viewBox: "0 0 102.59 117.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Done",
    transform: "translate(-59.664 -43.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M172.5,45v5.8",
    transform: "translate(-21.166)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M172.5,59v5.8",
    transform: "translate(-21.166 -0.462)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M162.5,55h5.8",
    transform: "translate(-20.836 -0.33)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M176.5,55h5.8",
    transform: "translate(-21.298 -0.33)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M89.5,148v3.868",
    transform: "translate(-18.429 -3.396)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M89.5,160v3.868",
    transform: "translate(-18.429 -3.792)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M81.5,156h3.868",
    transform: "translate(-18.165 -3.66)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M93.5,156h3.868",
    transform: "translate(-18.561 -3.66)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M158.017,128.649a44,44,0,0,0,8.725-17.628,44.644,44.644,0,0,0-53.991-53.752,44.236,44.236,0,0,0-32.942,34.6A44.634,44.634,0,0,0,127.8,144.773a44.216,44.216,0,0,0,17.306-5.328",
    transform: "translate(-18.083 -0.363)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M158.017,128.649a44,44,0,0,0,8.725-17.628,44.644,44.644,0,0,0-53.991-53.752,44.236,44.236,0,0,0-32.942,34.6A44.634,44.634,0,0,0,127.8,144.773a44.216,44.216,0,0,0,17.306-5.328",
    transform: "translate(-18.083 -0.363)",
    fill: "none",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M150.7,140.177a35.456,35.456,0,0,0,6.935-5.886Z",
    transform: "translate(-20.447 -2.944)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M150.7,140.177a35.456,35.456,0,0,0,6.935-5.886",
    transform: "translate(-20.447 -2.944)",
    fill: "none",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M164.23,103.146q-.415.007-.832.008A46.305,46.305,0,0,1,117.306,60a40.85,40.85,0,1,0,46.924,43.146Z",
    transform: "translate(-18.215 -0.495)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M108.857,99.965a2.878,2.878,0,0,0-4.1.188,2.954,2.954,0,0,0,.186,4.143L118.6,116.9a4.031,4.031,0,0,0,5.737-.262c.064-.072.064-.072.125-.144l19.485-23.69a2.955,2.955,0,0,0-.376-4.13,2.88,2.88,0,0,0-4.086.38L121.165,111.33Z",
    transform: "translate(-18.907 -1.418)",
    fill: "#165cf3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M110.082,64.413A38.572,38.572,0,0,0,96.8,72.818a39.173,39.173,0,0,0-2.761,2.955M91.38,79.329q-1.025,1.549-1.887,3.172-.636,1.2-1.183,2.428",
    transform: "translate(-18.39 -0.64)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M110.465,65.5a1.209,1.209,0,0,0-.849-2.264Zm-5.933,1.448.6,1.051Zm-7.773,5.826-.84-.87Zm-3.686,2.177a1.209,1.209,0,0,0,1.85,1.557Zm-.726,5a1.209,1.209,0,1,0-2.016-1.334Zm-2.895,2.5,1.067.567h0ZM87.165,84.4a1.209,1.209,0,1,0,2.209.982ZM109.616,63.24a39.676,39.676,0,0,0-5.681,2.66l1.2,2.1a37.274,37.274,0,0,1,5.335-2.5Zm-5.681,2.66a40,40,0,0,0-8.015,6.007L97.6,73.647A37.6,37.6,0,0,1,105.13,68ZM95.92,71.908a40.379,40.379,0,0,0-2.846,3.047l1.85,1.557A37.948,37.948,0,0,1,97.6,73.647Zm-5.588,6.713q-1.057,1.6-1.946,3.271l2.135,1.135q.834-1.57,1.827-3.072Zm-1.946,3.271q-.656,1.235-1.22,2.5l2.209.982q.53-1.192,1.146-2.352Z",
    transform: "translate(-18.349 -0.599)",
    fill: "#75a4fe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationDoneIcon);
export default __webpack_public_path__ + "static/media/registration-done-icon.eb772022e45103e69abac6c772d4e658.svg";
export { ForwardRef as ReactComponent };